// =============================================
// CARRUSEL TESTIMONIOS - CONTROL MANUAL
// =============================================
function initTestimonialSlider() {
    const slider = document.querySelector('.custom-testimonial-slider');
    if (!slider) return;
    
    const slides = document.querySelectorAll('.custom-testimonial-slide');
    const dots = document.querySelectorAll('.custom-slider-dot');
    const prevBtn = document.querySelector('.custom-prev-btn');
    const nextBtn = document.querySelector('.custom-next-btn');
    
    let currentSlide = 0;
    
    // Función para mostrar slide específico
    function showSlide(index) {
        // Validar índice
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        
        // Ocultar todos los slides
        slides.forEach(slide => slide.classList.remove('active'));
        dots.forEach(dot => dot.classList.remove('active'));
        
        // Mostrar slide actual
        slides[index].classList.add('active');
        dots[index].classList.add('active');
        
        currentSlide = index;
    }
    
    // Event listeners para botones de navegación
    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            showSlide(currentSlide - 1);
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            showSlide(currentSlide + 1);
        });
    }
    
    // Event listeners para dots de navegación
    dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
            showSlide(index);
        });
    });
    
    // Navegación por teclado
    document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
            showSlide(currentSlide - 1);
        } else if (e.key === 'ArrowRight') {
            showSlide(currentSlide + 1);
        }
    });
    
    // Navegación táctil (swipe)
    let touchStartX = 0;
    let touchEndX = 0;
    
    slider.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, false);
    
    slider.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, false);
    
    function handleSwipe() {
        const minSwipeDistance = 50; // Distancia mínima para considerar un swipe
        
        if (touchEndX < touchStartX && touchStartX - touchEndX > minSwipeDistance) {
            // Swipe izquierda - siguiente slide
            showSlide(currentSlide + 1);
        }
        
        if (touchEndX > touchStartX && touchEndX - touchStartX > minSwipeDistance) {
            // Swipe derecha - slide anterior
            showSlide(currentSlide - 1);
        }
    }
    
    // Inicializar primer slide
    showSlide(0);
}

// =============================================
// ACORDEÓN EBOOKS
// =============================================
function initEbookAccordion() {
    document.querySelectorAll('.ebook-accordion-item').forEach(item => {
        const header = item.querySelector('.ebook-accordion-header');
        
        if (header) {
            header.addEventListener('click', () => {
                // Cierra todos los demás ítems primero
                document.querySelectorAll('.ebook-accordion-item').forEach(otherItem => {
                    if (otherItem !== item && otherItem.classList.contains('active')) {
                        otherItem.classList.remove('active');
                    }
                });
                
                // Abre/cierra el ítem clickeado
                item.classList.toggle('active');
            });
        }
    });
}

// =============================================
// REVIEWS DROPDOWN
// =============================================
function initReviewsDropdown() {
    const reviewsHeader = document.getElementById('reviewsHeader');
    
    if (reviewsHeader) {
        reviewsHeader.addEventListener('click', function() {
            const content = document.getElementById('reviewsContent');
            const header = this;
            
            content.classList.toggle('active');
            header.classList.toggle('active');
            
            const icon = header.querySelector('.dropdown-icon i');
            if (header.classList.contains('active')) {
                icon.classList.remove('fa-chevron-down');
                icon.classList.add('fa-chevron-up');
            } else {
                icon.classList.remove('fa-chevron-up');
                icon.classList.add('fa-chevron-down');
            }
        });
    }
}

// =============================================
// CONTADOR DE PERSONAS VIENDO LA OFERTA
// =============================================
function initViewersCounter() {
    function updateViewersCounter() {
        const counterElements = document.querySelectorAll('#viewers-count');
        if (!counterElements.length) return;
        
        let viewers = Math.floor(Math.random() * 31) + 50;
        const variation = Math.floor(Math.random() * 11) - 5;
        viewers = Math.max(40, viewers + variation);
        
        counterElements.forEach(el => {
            el.textContent = viewers;
        });
    }

    if (document.querySelector('#viewers-count')) {
        updateViewersCounter();
        setInterval(updateViewersCounter, 120000);
    }
}

// =============================================
// COUNTDOWN TIMER
// =============================================
function initCountdownTimer() {
    function updateCountdown() {
        const totalMinutes = 20;
        const now = new Date();
        const countdownStart = localStorage.getItem('countdownStart');
        
        if (!countdownStart) {
            localStorage.setItem('countdownStart', now.getTime());
            return;
        }
        
        const startTime = parseInt(countdownStart);
        const elapsed = Math.floor((now.getTime() - startTime) / 1000);
        const remaining = Math.max(0, (totalMinutes * 60) - elapsed);
        
        const minutes = Math.floor(remaining / 60);
        const seconds = remaining % 60;
        
        document.querySelectorAll('.timer-number').forEach(el => {
            if (el.id.includes('hours')) {
                el.textContent = '00';
            } else if (el.id.includes('minutes')) {
                el.textContent = minutes.toString().padStart(2, '0');
            } else if (el.id.includes('seconds')) {
                el.textContent = seconds.toString().padStart(2, '0');
            }
        });
        
        if (remaining <= 0) {
            localStorage.removeItem('countdownStart');
        }
    }

    if (document.querySelector('.timer-number')) {
        setInterval(updateCountdown, 1000);
        updateCountdown();
    }
}

// =============================================
// NOTIFICACIONES DE COMPRA
// =============================================
function initPurchaseNotifications() {
    const notificationData = [
        { name: "María", location: "Mar del Plata", time: "hace 4 minutos" },
        { name: "Lucía", location: "Córdoba", time: "hace 12 minutos" },
        { name: "Ana", location: "Rosario", time: "hace 19 minutos" }
    ];

    function showRandomNotification() {
        const notification = document.getElementById('purchase-notification');
        if (!notification) return;
        
        const random = Math.floor(Math.random() * notificationData.length);
        const data = notificationData[random];
        
        const avatar = notification.querySelector('.notification-avatar');
        const name = notification.querySelector('.notification-name');
        const time = notification.querySelector('.notification-time');
        
        if (avatar) avatar.textContent = data.name.charAt(0);
        if (name) name.textContent = `${data.name} (${data.location})`;
        if (time) time.textContent = data.time;
        
        notification.classList.add('show');
        
        setTimeout(() => {
            notification.classList.remove('show');
        }, 5000);
    }

    setTimeout(showRandomNotification, 8000);
    setInterval(showRandomNotification, Math.random() * 30000 + 30000);
}

// =============================================
// FAQ ACCORDION
// =============================================
function initFaqAccordion() {
    document.querySelectorAll('.faq-question').forEach(question => {
        question.addEventListener('click', () => {
            const answer = question.nextElementSibling;
            const icon = question.querySelector('i');
            
            if (answer) answer.classList.toggle('active');
            if (icon) {
                icon.classList.toggle('fa-chevron-down');
                icon.classList.toggle('fa-chevron-up');
            }
        });
    });
}

// =============================================
// INICIALIZAR TODAS LAS FUNCIONALIDADES
// =============================================
document.addEventListener('DOMContentLoaded', function() {
    initTestimonialSlider();
    initEbookAccordion();
    initReviewsDropdown();
    initViewersCounter();
    initCountdownTimer();
    initPurchaseNotifications();
    initFaqAccordion();
});